export interface EditorJsBlock {
  id?: string;
  type: string;
  data: Record<string, unknown>;
}

export interface EditorJsOutputData {
  time?: number;
  version?: string;
  blocks: EditorJsBlock[];
}

export const TINYMCE_RICH_TEXT_TYPE = "wsm.richText.html" as const;

/**
 * The wrapper this app saved between PR 102 and WSM6-3450. Saleor never
 * accepted it (its EditorJS model refuses the type), so it is read for the
 * documents that reached a database through the old per-site backend and is
 * never written again: the editor saves `EditorJsOutputData`.
 */
export interface TinymceHtmlDocumentV1 {
  type: typeof TINYMCE_RICH_TEXT_TYPE;
  version: 1;
  editor: "tinymce";
  html: string;
  plainText: string;
}

export type RichTextDocument = EditorJsOutputData | TinymceHtmlDocumentV1;
export type RichTextRaw = RichTextDocument | string | null | undefined;
export type RichTextValue = RichTextDocument | string | null | undefined;

export interface RichTextEditorRef {
  save: () => Promise<RichTextDocument | null>;
  render?: (data?: RichTextValue) => void | Promise<void>;
  clear?: () => void | Promise<void>;
  destroy?: () => void | Promise<void>;
}
